import { styled } from 'styled-components';

/**
 * Use this styled component when you need to highlight a piece of header text.
 */
const StyledTextHighlight = styled('span')`
  color: var(--primary-color);
  border-bottom: 2px solid var(--primary-color);
`;

export default StyledTextHighlight;
